module.exports = __webpack_public_path__ + "img/time-3.11897bb4.jpg";